import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import BigNumber from 'bignumber.js';

export type GetClosePositionFeeParams = Omit<
  SettleForLiqTradeParams,
  'closeFee'
> & {
  isLVTokenPay: boolean;
  isDegen: boolean;
  lvTokenDiscountP: number;
  closeFeeP: number;
  pnl: BigNumber;
  shareP: number;
  minCloseFeeP: number;
  positionSize: BigNumber;
};
/**
 *
 * closeFee = positionQty * closePrice * closeFeeP
 *
 *
 * For open position, closePrice atm can only be the market price, so
 *      positionQty * closePrice = positionSize
 *
 * for close is positionQty * closePrice (pay attention to correct price)
 *
 * @param param0
 * @returns
 */
export const getClosePositionFee = ({
  isDegen,
  isLVTokenPay,
  closeFeeP,
  lvTokenDiscountP,
  positionSize,
  pnl,
  shareP,
  minCloseFeeP,
  fundingFee,
  holdingFee,
  collateralUsd,
}: GetClosePositionFeeParams) => {
  let closeFee = BigNumber(0);

  if (shareP > 0 && minCloseFeeP > 0) {
    if (pnl.isLessThanOrEqualTo(ZERO_BIG_NUMBER)) {
      closeFee = BigNumber(0);
    } else {
      const pnlSharePFee = pnl.multipliedBy(shareP);
      const positionSizeMinCloseFeeP = positionSize.multipliedBy(minCloseFeeP);
      closeFee = pnlSharePFee.isLessThan(positionSizeMinCloseFeeP)
        ? pnlSharePFee
        : positionSizeMinCloseFeeP;
    }
  } else {
    closeFee = positionSize.multipliedBy(closeFeeP);
  }

  let finalCloseFee = closeFee;
  if (isLVTokenPay) {
    const discount = closeFee.multipliedBy(lvTokenDiscountP).dividedBy(1e5);
    finalCloseFee = closeFee.minus(discount);
  }

  return {
    closeFee: settleForLiqTrade({
      closeFee: closeFee,
      pnl,
      fundingFee,
      holdingFee,
      collateralUsd,
    }),
    finalCloseFee: settleForLiqTrade({
      closeFee: finalCloseFee,
      pnl,
      fundingFee,
      holdingFee,
      collateralUsd,
    })
  };
};

/**
 *
 * final settle for close  position fee
 *
 * returning final closeFee
 */

type SettleForLiqTradeParams = {
  collateralUsd: BigNumber;
  fundingFee: BigNumber;
  holdingFee: BigNumber;
  pnl: BigNumber;
  closeFee: BigNumber;
};

const settleForLiqTrade = ({
  collateralUsd,
  fundingFee, // funding fee can be negative / positive
  pnl, // pnl can be negative  / positive
  closeFee,
  holdingFee, // positive always
}: SettleForLiqTradeParams) => {
  const openTradeReceive = collateralUsd.minus(fundingFee).minus(holdingFee);
  const openTradeReceiveWithPnl = openTradeReceive.plus(pnl);

  if (openTradeReceiveWithPnl.isGreaterThanOrEqualTo(closeFee)) {
    return closeFee;
  } else if (
    openTradeReceiveWithPnl.isGreaterThan(0) &&
    openTradeReceiveWithPnl.isLessThan(closeFee)
  ) {
    return openTradeReceiveWithPnl;
  } else {
    return ZERO_BIG_NUMBER;
  }
};